var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,2c-7.168,0 -13,8.29233 -13,18.48633c0,5.26619 1.56494,10.00832 4.06055,13.37305c-0.19039,1.02259 0.08393,2.07689 0.74856,2.87702c0.66464,0.80013 1.65072,1.26318 2.69089,1.2636c1.933,0 3.5,-1.567 3.5,-3.5c0,-1.933 -1.567,-3.5 -3.5,-3.5c-0.19052,0.00143 -0.3806,0.01841 -0.56836,0.05078c-1.78808,-2.66355 -2.93164,-6.43932 -2.93164,-10.56445c0,-7.853 4.122,-14.48633 9,-14.48633c4.119,0 7.68913,4.7375 8.70313,10.9375c1.422,0.408 2.83856,0.95995 4.22656,1.62695c-0.678,-9.294 -6.21769,-16.56445 -12.92969,-16.56445zM22.5,17c-1.933,0 -3.5,1.567 -3.5,3.5c0,1.933 1.567,3.5 3.5,3.5c1.33477,-0.00071 2.55294,-0.76055 3.14063,-1.95898c3.24975,-0.20353 7.00547,0.7991 10.47266,2.87695c6.86,4.113 10.59053,11.30508 8.14453,15.70508c-0.804,1.446 -2.25245,2.48591 -4.18945,3.00391c-2.789,0.746 -6.20912,0.36672 -9.57812,-0.98828c-1.069,0.994 -2.24434,1.92716 -3.52734,2.78516c3.328,1.681 6.84761,2.57227 10.09961,2.57227c1.41,0 2.77102,-0.16586 4.04102,-0.50586c3.007,-0.805 5.30739,-2.50783 6.65039,-4.92383c3.584,-6.449 -0.62598,-15.70812 -9.58398,-21.07812c-4.26247,-2.55641 -8.98438,-3.73447 -13.13477,-3.39453c-0.65947,-0.69658 -1.57593,-1.09197 -2.53516,-1.09375zM9.16016,23.32422c-7.081,5.471 -10.11811,13.47519 -6.91211,19.24219c1.343,2.416 3.64339,4.11883 6.65039,4.92383c1.271,0.34 2.62902,0.50586 4.04102,0.50586c3.8,0 7.97058,-1.20642 11.76758,-3.48242c4.24784,-2.54671 7.38872,-5.96995 9.16992,-9.55078c1.7511,-0.19075 3.12305,-1.66185 3.12305,-3.46289c0,-1.93 -1.57,-3.5 -3.5,-3.5c-1.93,0 -3.5,1.57 -3.5,3.5c0,0.54022 0.13208,1.04663 0.35156,1.50391c-1.44393,2.97478 -4.13811,5.94148 -7.70117,8.07813c-4.296,2.576 -9.05075,3.52792 -12.71875,2.54492c-1.936,-0.518 -3.3835,-1.55791 -4.1875,-3.00391c-1.934,-3.48 0.00216,-8.69958 4.28516,-12.76758c-0.411,-1.44 -0.70514,-2.95625 -0.86914,-4.53125z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.cd37ef5cedf02c735d0fc0167c5ed483.svg";
export { ForwardRef as ReactComponent };